import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-57950595"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "guide" }
const _hoisted_2 = { class: "guide-container" }
const _hoisted_3 = { class: "header" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "title-icon" }),
  /*#__PURE__*/_createTextVNode(" 生活指数 ")
], -1))
const _hoisted_5 = { class: "updata-time" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "current-time" }, "更新于：", -1))
const _hoisted_7 = { class: "txt-time" }
const _hoisted_8 = { class: "icon" }
const _hoisted_9 = { class: "content-container" }
const _hoisted_10 = { class: "content-title" }
const _hoisted_11 = { class: "level" }
const _hoisted_12 = { class: "content" }

import moment from 'moment';
import { useStore, } from 'vuex';
import {
  computed, onMounted, watch,ref,
} from 'vue';
import qs from 'qs';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore();

const regionId = computed<number>(() => store.state.OLMap.regionId) || 320100000000;

watch(regionId, (curRe:number): void => {
  store.dispatch('gateway/loadLifeSuggestionList', qs.stringify({ regionId: curRe, }));
});

const lifeSuggestionList = computed(() => store.state.gateway.lifeSuggestionList);

/**
 * 配置图标
 * @param {string} val suggestType
 * @return {string} 图标
 */
const getSuggestTypeIcon = (val: string): string => {
  switch (true) {
  case val === '洗车指数':
    return 'icon-qiche2';
  case val === '紫外线指数':
    return 'icon-san';
  case val === '感冒指数':
    return 'icon-medicine';
  case val === '运动指数':
    return 'icon-paobu';
  case val === '过敏指数':
    return 'icon-jujia-shafa';
  case val === '穿衣指数':
    return 'icon-yifu';
  default:
    return 'icon-yifu';
  }
};

onMounted(() => {
  if (regionId.value) {
    store.dispatch(
      'gateway/loadLifeSuggestionList',
      qs.stringify({ regionId: regionId.value, })
    );
  }
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(lifeSuggestionList)[0]?.weatherDate.replace(' 00:00:00', '')), 1)
        ])
      ]),
      _createElementVNode("ul", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(lifeSuggestionList), (item, index) => {
          return (_openBlock(), _createElementBlock("li", { key: index }, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("span", {
                class: _normalizeClass(["iconfont", getSuggestTypeIcon(item.suggestType)])
              }, null, 2)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", null, _toDisplayString(item.suggestType), 1),
                _createElementVNode("div", _hoisted_11, _toDisplayString(item.suggestDesc), 1)
              ]),
              _createElementVNode("div", _hoisted_12, _toDisplayString(item.suggestDetail), 1)
            ])
          ]))
        }), 128))
      ])
    ])
  ]))
}
}

})